import { Icon, Tag } from '@kontentino/ui';
import ColorUtils from 'app/utils/color';
import clsx from 'clsx';
import React, { ComponentProps, FC } from 'react';
import { useTheme } from 'utils/hooks/useTheme';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';

export type LabelTagProps = {
  name: string;
  color?: string;
  onRemove?: () => void;
} & Omit<ComponentProps<typeof Tag>, 'children'>;

const LabelTag: FC<LabelTagProps> = ({
  name,
  color,
  onRemove,
  className,
  style,
  ...props
}) => {
  const theme = useTheme();
  const backgroundColor = color ?? theme.colors.white;

  return (
    <Tag
      size="medium"
      style={{
        backgroundColor,
        color: ColorUtils.hasLowContrastRatio(
          theme.colors.grayscale['180'],
          backgroundColor,
        )
          ? theme.colors.white
          : theme.colors.grayscale['180'],
        ...style,
      }}
      className={clsx('tw-max-w-[250px] tw-overflow-hidden', className)}
      {...props}
    >
      <span className="tw-line-clamp-1 tw-text-ellipsis tw-break-all">
        {name}
      </span>
      {onRemove && (
        <button
          type="button"
          className="tw-ml-1 tw-inline-flex tw-shrink-0 tw-items-center tw-opacity-60 hover:tw-opacity-100"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
        >
          <Icon icon={faXmark} size="sm" />
        </button>
      )}
    </Tag>
  );
};

export default LabelTag;
